import { ReactNode, useEffect, useState } from "react";

import { ROUTES } from "@/shared";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import DialogCustom from "../../../DialogCustom/DialogCustom";
import useTutorialMode from "../../../TutorialMode/hooks/useTutorialMode";
import { STEP_GROUP } from "../../../TutorialMode/types";

interface MobileDetailsProps {
  route: ROUTES;
  children: ReactNode;
}

const MobileDetails = ({ route, children }: MobileDetailsProps) => {
  const {
    stepGroup,
    stepIndex,
    checkIfCorrectTutorialStep,
    setTutorialDetails
  } = useTutorialMode();

  const { detailsData, setParams, setDetailsData } =
    useTableStoreByRoute(route);

  const [isOpen, setIsOpen] = useState(Boolean(detailsData));

  useEffect(() => {
    if (detailsData) {
      setIsOpen(true);

      setParams({
        desktopDetailsSection: true,
        selectedTableItem: detailsData.id,
        ...(route === ROUTES.Integrations && {
          selectedTableItemUrlKey: detailsData.type
        })
      });
    } else {
      setIsOpen(false);
    }
  }, [route, detailsData]);

  useEffect(() => {
    if (isOpen) {
      checkIfCorrectTutorialStep(STEP_GROUP.TutorialNewCompanyCard, 3) &&
        setTutorialDetails({
          isTutorialOpen: true,
          stepIndex: stepIndex,
          stepGroup: stepGroup,
          isTutorialActive: false
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, stepIndex]);

  const handleCloseDialog = () => {
    setParams({
      desktopDetailsSection: false,
      selectedTableItem: null,
      ...(route === ROUTES.Integrations && {
        selectedTableItemUrlKey: null
      })
    });

    setDetailsData(null);
    setIsOpen(false);
  };

  return detailsData ? (
    <DialogCustom
      data-testid="mobile-details-dialog"
      fullWidth
      open={isOpen}
      close={handleCloseDialog}
      transitionDuration={0}
      noPadding
    >
      {children}
    </DialogCustom>
  ) : null;
};

export default MobileDetails;
